import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import loaderImage from "../../../../../../public/images/loader.png";
import "./sbs-loader.css";

@customElement("sbs-loader")
export class SBSLoader extends LitElement {
  @property({ type: Object })
  customStyle: Record<string, string> = {};

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  render() {
    return html`
      <div
        class="sbs-data-loader-container"
        style=${this.styleMap(this.customStyle)}
      >
        <img src=${loaderImage} class="loader-img spin-loader" />
      </div>
    `;
  }

  private styleMap(styleObj: Record<string, string>): string {
    return Object.entries(styleObj)
      .map(([key, value]) => `${key}: ${value}`)
      .join("; ");
  }
}
